var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueBackgroundDim(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_4981)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 0H1920V1080H1V0Z",
    fill: "url(#paint0_linear_1_4981)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.000244141,
    width: 1920.5,
    height: 1080,
    fill: "url(#paint1_linear_1_4981)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1418.74 793.889C1367.44 785.894 1316.74 774.211 1268.01 758.81L1265.75 765.756L1314.7 778.858L1280.35 907.155L1173.44 878.535L1207.78 750.238L1258.61 763.845L1260.99 756.559C1193.83 734.753 1130.61 705.828 1075 669.709L1079.36 663C1134.32 698.704 1196.91 727.342 1263.46 748.952L1265.94 741.355L1272.95 743.64L1270.49 751.203C1348.87 775.971 1432.52 791.072 1515.54 796.564C1534.7 797.831 1553.81 798.587 1572.81 798.832L1573.08 793.767L1580.45 794.158L1580.2 798.901C1632.2 799.21 1683.28 795.686 1731.95 788.363L1731.74 787.523L1738.92 785.793L1739.26 787.23C1812.58 775.563 1880.19 755.188 1936.9 726.227L1940.54 733.352C1883.15 762.661 1814.95 783.233 1741.14 795.031L1743.19 803.53L1795.73 792.234L1823.65 922.082L1715.44 945.345L1687.53 815.498L1735.98 805.081L1733.83 796.169C1684.38 803.65 1632.51 807.23 1579.77 806.898L1579.22 817.384L1629.89 817.372L1629.92 950.186L1519.24 950.212L1519.21 817.398L1571.83 817.386L1572.39 806.826C1553.34 806.575 1534.2 805.815 1515.02 804.547C1485.36 802.585 1455.61 799.405 1426.03 795.001L1423.73 808.038L1474.75 818.354L1448.42 948.533L1339.94 926.596L1366.26 796.417L1416.5 806.575L1418.74 793.889Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1530.61,
    y: 828.128,
    width: 88.5427,
    height: 88.5427,
    fill: "#7386FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1216.02,
    y: 763.555,
    width: 88.5427,
    height: 88.5427,
    transform: "rotate(14.9863 1216.02 763.555)",
    fill: "#7386FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1700.93,
    y: 823.593,
    width: 88.5427,
    height: 88.5427,
    transform: "rotate(-12.1333 1700.93 823.593)",
    fill: "#7386FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1375.31,
    y: 809.195,
    width: 88.5427,
    height: 88.5427,
    transform: "rotate(11.4323 1375.31 809.195)",
    fill: "#7386FF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327.105 802.203C275.203 801.109 223.392 796.281 173.051 787.506L171.734 794.69L221.991 801.159L205.035 932.886L95.2626 918.757L112.218 787.03L164.406 793.747L165.787 786.21C96.33 773.54 29.8142 753.291 -30.1064 724.898L-26.6808 717.669C32.5507 745.735 98.395 765.785 167.229 778.341L168.67 770.483L175.928 771.813L174.494 779.636C255.474 793.748 340.393 797.575 423.405 791.964C442.558 790.669 461.602 788.873 480.466 786.586L480.058 781.53L487.412 780.937L487.794 785.671C539.377 779.053 589.533 768.759 636.789 755.021L636.476 754.216L643.355 751.546L643.89 752.924C715.003 731.598 779.295 702.403 831.645 666.149L836.199 672.726C783.221 709.415 718.369 738.885 646.794 760.405L649.957 768.555L700.524 750.364L745.481 875.338L641.336 912.802L596.379 787.828L643.012 771.053L639.695 762.507C591.68 776.506 540.753 786.96 488.438 793.654L489.283 804.12L539.5 797.361L557.216 928.989L447.527 943.752L429.81 812.125L481.96 805.106L481.109 794.566C462.202 796.853 443.123 798.649 423.945 799.946C394.292 801.95 364.384 802.759 334.484 802.333L333.938 815.56L385.874 818.992L377.117 951.517L266.68 944.22L275.436 811.695L326.573 815.074L327.105 802.203Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.544,
    y: 821.24,
    width: 88.5427,
    height: 88.5427,
    transform: "rotate(-7.66557 442.544 821.24)",
    fill: "#7386FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.157,
    y: 799.13,
    width: 88.5427,
    height: 88.5427,
    transform: "rotate(7.33443 122.157 799.13)",
    fill: "#7386FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 610.742,
    y: 794.066,
    width: 88.5428,
    height: 88.5428,
    transform: "rotate(-19.7851 610.742 794.066)",
    fill: "#7386FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.107,
    y: 823.155,
    width: 88.5427,
    height: 88.5427,
    transform: "rotate(3.78045 286.107 823.155)",
    fill: "#7386FF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1432.56 543.789C1338.9 520.976 1250.04 485.291 1175 436.548L1179.9 429C1253.96 477.101 1341.82 512.413 1434.59 535.02L1435.82 529.692L1443.75 531.522L1442.5 536.915C1499.66 550.359 1558.57 559.01 1617.16 562.887C1618.78 562.994 1620.4 563.097 1622.02 563.197L1623.05 553.366L1631.15 554.22L1630.15 563.668C1687.55 566.778 1744.44 565.293 1798.85 559.263L1798.17 555.6L1806.17 554.106L1806.96 558.329C1893.72 547.944 1973.91 525.9 2039.53 492.392L2043.62 500.407C1977.06 534.396 1896.05 556.675 1808.61 567.194L1809.86 573.888L1868.38 564.464L1891.67 709.087L1771.15 728.496L1747.86 583.873L1801.83 575.182L1800.51 568.134C1745.18 574.304 1687.41 575.807 1629.2 572.63L1628.46 579.731L1684.27 582.628L1676.67 728.918L1554.77 722.591L1562.36 576.301L1620.32 579.309L1621.07 572.156C1619.57 572.063 1618.07 571.966 1616.57 571.867C1557.55 567.963 1498.16 559.249 1440.48 545.684L1438.57 553.93L1494.17 568.223L1457.7 710.097L1339.47 679.704L1375.95 537.83L1430.69 551.903L1432.56 543.789Z",
    fill: "url(#paint2_linear_1_4981)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1574.3,
    y: 588.773,
    width: 97.6578,
    height: 97.6578,
    transform: "rotate(2.97079 1574.3 588.773)",
    fill: "#7386FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1762.16,
    y: 593.561,
    width: 97.6578,
    height: 97.6578,
    transform: "rotate(-9.14878 1762.16 593.561)",
    fill: "#7386FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1385.18,
    y: 552.426,
    width: 97.6578,
    height: 97.6578,
    transform: "rotate(14.4168 1385.18 552.426)",
    fill: "#7386FF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M526.058 529.789C619.719 506.976 708.579 471.291 783.621 422.548L778.719 415C704.665 463.101 616.8 498.413 524.034 521.02L522.804 515.692L514.874 517.522L516.119 522.915C458.965 536.359 400.056 545.01 341.459 548.887C339.841 548.994 338.223 549.097 336.605 549.197L335.568 539.366L327.474 540.22L328.471 549.668C271.067 552.778 214.184 551.293 159.767 545.263L160.451 541.6L152.451 540.106L151.663 544.329C64.8981 533.944 -15.2901 511.9 -80.9069 478.392L-85.0001 486.407C-18.4432 520.396 62.5757 542.675 150.007 553.194L148.758 559.888L90.2404 550.464L66.9492 695.087L187.468 714.496L210.76 569.873L156.795 561.182L158.111 554.134C213.437 560.304 271.21 561.807 329.417 558.63L330.166 565.731L274.356 568.628L281.948 714.918L403.856 708.591L396.264 562.301L338.305 565.309L337.55 558.156C339.051 558.063 340.552 557.966 342.053 557.867C401.072 553.963 460.465 545.249 518.143 531.684L520.047 539.93L464.448 554.223L500.919 696.097L619.147 665.704L582.676 523.83L527.931 537.903L526.058 529.789Z",
    fill: "url(#paint3_linear_1_4981)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 97.6578,
    height: 97.6578,
    transform: "matrix(-0.998656 0.0518269 0.0518269 0.998656 384.317 574.773)",
    fill: "#7386FF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 97.6578,
    height: 97.6578,
    transform: "matrix(-0.987279 -0.158999 -0.158999 0.987279 196.46 579.561)",
    fill: "#7386FF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 97.6578,
    height: 97.6578,
    transform: "matrix(-0.96851 0.248974 0.248974 0.96851 573.441 538.426)",
    fill: "#7386FF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2006.32 263.581C1891.86 259.099 1773.89 244.855 1657.66 215.724L1659.35 208.098L1641.18 204.076L1639.63 211.081C1412.74 151.081 1193.51 33.1518 1021.13 -181L1011 -172.848C1185.64 44.106 1407.65 163.27 1636.82 223.779L1632.51 243.244L1529.1 222.076L1475.06 486.047L1695.04 531.076L1749.07 267.104L1650.75 246.977L1654.85 228.417C1772.03 257.752 1890.8 272.068 2005.81 276.571L2006.32 263.581Z",
    fill: "#BBD7FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1546.59,
    y: 248.576,
    width: 179.63,
    height: 179.63,
    transform: "rotate(11.5685 1546.59 248.576)",
    fill: "#5B9AFF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-68.2681 233.039C40.8312 246.166 158.41 240.412 276.893 198.748L272.882 187.959L290.325 181.475L294.366 192.344C417.501 145.361 541.209 58.736 657 -86.6126L667.168 -78.5124C549.783 68.8371 424.101 156.786 298.896 204.529L302.961 215.462L402.041 184.52L482.362 441.715L268.033 508.649L187.712 251.454L285.172 221.018L281.423 210.934C160.908 253.35 41.2143 259.306 -69.8211 245.946L-68.2681 233.039Z",
    fill: "#BBD7FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.839,
    y: 266.193,
    width: 179.63,
    height: 179.63,
    transform: "rotate(-17.3433 215.839 266.193)",
    fill: "#5B9AFF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_4981",
    x1: 960.5,
    y1: 0,
    x2: 960.5,
    y2: 1080,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18C6E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9AAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_4981",
    x1: 960.25,
    y1: 0,
    x2: 960.25,
    y2: 1080,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18C6E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9AAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_4981",
    x1: 2043.62,
    y1: 578.959,
    x2: 1175,
    y2: 578.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9D3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9D3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_4981",
    x1: -85.0001,
    y1: 564.959,
    x2: 783.621,
    y2: 564.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9D3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9D3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_4981"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueBackgroundDim);
export default __webpack_public_path__ + "static/media/BlueBackgroundDim.8b4b8885a71a6d0fab88.svg";
export { ForwardRef as ReactComponent };